module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bidding"
  }, [_c('banner', {
    staticClass: "bidding-banner",
    attrs: {
      "url": "bidding"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    on: {
      "click": function($event) {
        return _vm.handleRegister('zhaotoubiao-banner-shiyong')
      }
    }
  }, [_vm._v("立即试用")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("咨询客服")])], 1)], 2), _vm._v(" "), _c('div', {
    class: ("bidding-section2 " + _vm.specialStyle2)
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', [_vm._v("超越传统招投标，扩源易用，优化招标过程")]), _vm._v(" "), _c('p', [_vm._v("甄云招投标系统，聚焦多组织中大型企业，以\n        “整合、实用，开放”三大特性持续优化企业招投标过程，提升采购性价比，规范招采流程，达到降本增效。服务涵盖：多渠道信息发布、供应商甄选、招标创建及开标、专家库建立、竞价模式、询比价管理、图形化评标报告、招标进度监控及预警、防止围标、电子签章等全场景服务，帮助企业实现更强的议价能力，\n        更全面的招采掌控，提升企业数字化能力。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    on: {
      "click": function($event) {
        return _vm.handleRegister('zhaotoubiao-chanpin-yanshi')
      }
    }
  }, [_vm._v("预约演示\n          "), _c('img', {
    attrs: {
      "src": require("../../assets/img/bidding/icon_demo.svg"),
      "alt": "预约演示"
    }
  })])], 1), _vm._v(" "), _c('img', {
    staticClass: "section2-img",
    attrs: {
      "alt": "超越传统招投标",
      "src": require("../../assets/img/bidding/illustrator_keyword.svg")
    }
  })])]), _vm._v(" "), _c('div', {
    class: ("bidding-section3 " + _vm.specialStyle3)
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_c('h1', [_vm._v("产品特色")]), _vm._v(" "), _c('div', {
    staticClass: "section3-list"
  }, _vm._l((_vm.section3List), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "section3-item"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": item.title
      }
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.content))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "section3-button"
  }, [_c('el-button', {
    staticClass: "banner-button",
    on: {
      "click": function($event) {
        return _vm.handleRegister('zhaotoubiao-tese-shiyong')
      }
    }
  }, [_vm._v("立即试用")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("咨询客服")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bidding-section4"
  }, [_c('h1', [_vm._v("面向招采需求的核心应用")]), _vm._v(" "), _c('div', {
    class: ("section4-content " + (_vm.specialStyle4.item1))
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "item-img",
    attrs: {
      "alt": "覆盖招投标全过程",
      "src": require("../../assets/img/bidding/illustrator_coreapp_01.svg")
    }
  })]), _vm._v(" "), _c('div', {
    class: ("section4-content " + (_vm.specialStyle4.item2)),
    staticStyle: {
      "margin-top": "165px !important"
    }
  }, [_c('img', {
    staticClass: "item-img",
    attrs: {
      "alt": "竞价模式多样",
      "src": require("../../assets/img/bidding/illustrator_coreapp_02.svg")
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    class: ("section4-content " + (_vm.specialStyle4.item3)),
    staticStyle: {
      "margin-top": "165px !important"
    }
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "item-img",
    attrs: {
      "alt": "招标全过程监控可查",
      "src": require("../../assets/img/bidding/illustrator_coreapp_03.svg")
    }
  })]), _vm._v(" "), _c('div', {
    class: ("section4-content " + (_vm.specialStyle4.item4)),
    staticStyle: {
      "margin-top": "182px !important"
    }
  }, [_c('img', {
    staticClass: "item-img",
    attrs: {
      "alt": "招投标拓展功能",
      "src": require("../../assets/img/bidding/illustrator_coreapp_04.svg")
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "section4-button"
  }, [_c('el-button', {
    staticClass: "banner-button",
    on: {
      "click": function($event) {
        return _vm.handleRegister('zhaotoubiao-hexin-gengduo')
      }
    }
  }, [_vm._v("了解更多")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bidding-section5"
  }, [_c('h1', [_vm._v("助力众多行业的领军企业")]), _vm._v(" "), _c('div', {
    staticClass: "section5-content"
  }, _vm._l((_vm.caseData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "section5-item"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.bidding_img),
        expression: "$global.globalPath + item.bidding_img"
      }],
      attrs: {
        "alt": item.title
      }
    })])
  }), 0), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "bidding-section6"
  }, [_c('h1', [_vm._v("客户感言")]), _vm._v(" "), _c('speech-swiper', {
    attrs: {
      "mark": 2
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("多模式覆盖招投标全过程")]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("招标计划及项目维护")]), _vm._v(" "), _c('span', [_vm._v("招标书创建、多种价格策略、多种合同模板、开标中标等全流程")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("供应商严选，降低采购风险")]), _vm._v(" "), _c('span', [_vm._v("设有供应商注册、认证、初审、考察、评审等筛选机制")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("专家评分管理，确保科学公正")]), _vm._v(" "), _c('span', [_vm._v("集团级专家库管理， 严把专家准入关")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("竞标模式多样，带来降本效应")]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("竞价模式")]), _vm._v(" "), _c('span', [_vm._v("供应商之间相互竞价，提升降价空间，还价历史清晰可查")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("询比价管理 ")]), _vm._v(" "), _c('span', [_vm._v("允许多轮还比价，完整记录整个过程，且可自动导入ERP")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("招标全流程的进度监控及预警")]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("预警自定义设置，有效监控")]), _vm._v(" "), _c('span', [_vm._v("实现事前待办提醒 、流程节点通知 、故障报告等")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("统一移动应用平台")]), _vm._v(" "), _c('span', [_vm._v("预警通过邮件、微信、邮箱等终端触达，实时提醒")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("拓展功能提升体验，让业务更顺畅")]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("集成具有CA认证的第三方电子签章系统")]), _vm._v(" "), _c('span', [_vm._v("标书生成PDF时自动嵌入电子签章，实现对标书的加密及管理")])]), _vm._v(" "), _c('div', {
    staticClass: "content-item"
  }, [_c('h2', [_vm._v("通过投标情况对比，自动预警围串标风险")]), _vm._v(" "), _c('span', [_vm._v("通过对供应商IP地址历史对比、标书雷同、以及录音录像三步走，自动破解围串标风险")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/clientele",
      "target": "_blank"
    }
  }, [_vm._v("查看更多客户案例 >")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-203b5dc5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/bidding.vue
// module id = 566
// module chunks = 12